import { render, staticRenderFns } from "./GhostwritingGoalsModal.vue?vue&type=template&id=4794dfc4&"
import script from "./GhostwritingGoalsModal.vue?vue&type=script&lang=js&"
export * from "./GhostwritingGoalsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports